import React from 'react';
import { useLocation } from 'react-router-dom';
import NovaChatWidget from './NovaChatWidget';

/**
 * Mounts Nova chat widget on all public pages.
 * Excluded routes: agent portal, admin dashboard, agent signup
 * (Auri is the AI for the agent portal — Nova should not appear there.)
 */
const EXCLUDED_PATHS = ['/agent-portal', '/admin', '/agent-signup'];

const GlobalNova = () => {
  const { pathname } = useLocation();
  if (EXCLUDED_PATHS.some((p) => pathname.startsWith(p))) return null;
  return <NovaChatWidget />;
};

export default GlobalNova;
